import axios, { AxiosInstance } from "axios";
import { getAuthToken } from "./tokenStore";
import emitter from "./eventEmitter"; // Import the event emitter

const axiosInstance: AxiosInstance = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle global errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Emit a logout event
      emitter.emit("logout");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
